import rootActions from "../rootActions";

class documentActions extends rootActions {
  constructor(params) {
    super(params);
  }
}

export default documentActions;
